export default __webpack_public_path__ + "assets/images/7a8be3186262b8032f62ac711d2b32dd.jpg";